import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
  kpiDetails: [],
  kpiLoading: false,
};

export const getKpiData = createAsyncThunk("get-kpi-data", (props) => {
  return new Promise((resolve, reject) => {
    const { location_id, module_id, payload } = props;
    axios
      .post(`kpi-detail/${location_id}/${module_id}`, payload)
      .then((res) => {
        if (res?.data?.err === 0) {
          if (Object.keys(res?.data?.data).length > 0) {
            resolve(res.data?.data);
          } else {
            toast.error("No Data Found");
            resolve({});
          }
        } else {
          toast.error(res?.data?.msg);
          reject({ message: res?.data?.msg });
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.msg);
        reject(error);
      });
  });
});

export const kpiSlice = createSlice({
  name: "kpi",
  initialState,
  reducers: {
    setKpiDetailsData: (state, action) => {
      state.kpiDetails = action.payload;
    },
  },
  extraReducers: {
    [getKpiData.pending]: (state) => {
      state.kpiDetails = [];
      state.kpiLoading = true;
    },
    [getKpiData.rejected]: (state) => {
      state.kpiDetails = [];
      state.kpiLoading = false;
    },
    [getKpiData.fulfilled]: (state, action) => {
      state.kpiDetails = action.payload;
      state.kpiLoading = false;
    },
  },
});
export const { setKpiDetailsData } = kpiSlice.actions;
export default kpiSlice.reducer;
